(function ($) {
    "use strict";
    $('.cookie-alert').on('closed.bs.alert', function () {
        Cookies.set('hideCookieConsent', true, { expires: 180 });
    });
})(jQuery);